import { SapMasterEmployees } from "../../features"

const SapMasterEmployeesPage = () => {
  return <SapMasterEmployees />
}

export default SapMasterEmployeesPage
